import React, { useState } from "react";
import Acts from "./Acts";
import Rules from "./Rules";
import Circulars from "./Circulars";

function ActAndRuleParent() {
  const [tabs, setTabs] = useState("Acts");

  // helper for keyboard navigation
  const handleKeyDown = (e, tabName) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      setTabs(tabName);
    }
  };

  return (
    <>
      <div className="common-bg mb-4">
        <div className="container">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 act-rule-sec">
            <ul className="nav nav-pills mb-4">
              <li className="nav-item">
                <span
                  role="button"
                  tabIndex="0"
                  aria-label="View Acts section"
                  className={tabs === "Acts" ? "nav-link active" : "nav-link"}
                  onClick={() => setTabs("Acts")}
                  onKeyDown={(e) => handleKeyDown(e, "Acts")}
                >
                  Acts
                </span>
              </li>
              <li className="nav-item">
                <span
                  role="button"
                  tabIndex="0"
                  aria-label="View Rules and Regulations section"
                  className={tabs === "Rules" ? "nav-link active" : "nav-link"}
                  onClick={() => setTabs("Rules")}
                  onKeyDown={(e) => handleKeyDown(e, "Rules")}
                >
                  Rules & Regulations
                </span>
              </li>

              {/* Uncomment if needed */}
              {/* <li className="nav-item">
                <span
                  role="button"
                  tabIndex="0"
                  aria-label="View Circulars section"
                  className={tabs === "Circulars" ? "nav-link active" : "nav-link"}
                  onClick={() => setTabs("Circulars")}
                  onKeyDown={(e) => handleKeyDown(e, "Circulars")}
                >
                  Circulars
                </span>
              </li> */}
            </ul>

            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
              <div className="about-content p-0">
                {tabs === "Acts" ? (
                  <h6>Acts </h6>
                ) : tabs === "Rules" ? (
                  <h6>Rules & Regulations </h6>
                ) : (
                  <h6>Circulars </h6>
                )}
              </div>
            </div>

            <div className="tab-content" id="pills-tabContent">
              {tabs === "Acts" ? (
                <div
                  className="tab-pane fade show active"
                  id="pills-auction"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                >
                  <Acts />
                </div>
              ) : tabs === "Rules" ? (
                <div
                  className="tab-pane fade show active"
                  id="pills-pn"
                  role="tabpanel"
                  aria-labelledby="pills-profile-tab"
                >
                  <Rules />
                </div>
              ) : (
                <div
                  className="tab-pane fade show active"
                  id="pills-tender"
                  role="tabpanel"
                  aria-labelledby="pills-contact-tab"
                >
                  <Circulars />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ActAndRuleParent;
